import { IsOptional } from "class-validator";

export class CreateQueueDto {
  @IsOptional()
  readonly queueId: string;

  @IsOptional()
  readonly currency: string;

  readonly entryFee: number;
  readonly startDate: Date;
  readonly totalParticipants: number;
  readonly arena: string;
}
